// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://workpass.baguio.gov.ph/api",
  firebase: {
    projectId: "workpass-production",
    appId: "1:650816047468:web:2bdc877dddf95dc9260b49",
    storageBucket: "workpass-production.appspot.com",
    apiKey: "AIzaSyAyzmsnfYYnkhXSj5K1Hi3o9rLVJXRVAQc",
    authDomain: "workpass-production.firebaseapp.com",
    messagingSenderId: "650816047468",
    measurementId: "G-7PC8P3Z8VS",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
